import React, { RefObject } from 'react';
import { TouchableOpacity } from 'react-native';
import { useDispatch } from 'react-redux';
import { MaterialCommunityIcons } from '@expo/vector-icons';
import { COLOR_GRAY } from '../../constants/color';
import {
	MESSAGE_SAVE_FAIL,
	MESSAGE_SAVE_SUCCESS,
} from '../../constants/message';
import { vw } from '../../constants/size';
import { tmpSlice } from '../../store/redux/modules/tmp/tmpSlice';
import takeCapture from '../../utils/takeCapture';

type Props = {
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	captureTargetRef: RefObject<any>;
};

const SaveButton: React.VFC<Props> = ({ captureTargetRef }) => {
	const dispatch = useDispatch();

	const _handleSuccess = () => {
		dispatch(tmpSlice.actions.showMessage(MESSAGE_SAVE_SUCCESS));
	};

	const _handleFail = () => {
		dispatch(tmpSlice.actions.showMessage(MESSAGE_SAVE_FAIL));
	};

	const handlePress = async () => {
		await takeCapture(captureTargetRef, _handleSuccess, _handleFail);
	};
	return (
		<TouchableOpacity onPress={handlePress}>
			<MaterialCommunityIcons
				name="content-save-outline"
				size={vw / 20}
				color={COLOR_GRAY}
			/>
		</TouchableOpacity>
	);
};

export default SaveButton;
